import { useEffect } from "react";
import { Col } from "react-bootstrap";
import { connect } from "react-redux";

import { send as pageInfo } from "../../../actions/pages";

const Display = ({ pageInfo }) => {
    useEffect(() => {
        pageInfo({
            title: "Client Dashboard",
            breadcrumb: "Dashboard",
            description: "Client facing dashboard"
        });
    }, [pageInfo]);

    return (
        <Col md="8" className="float-right text-end" />
    );
};

export default connect(null, { pageInfo })(Display);
